module.exports = __webpack_public_path__ + "teqbahn-assets/media/slider_2_icon.9756ed71.png";